export default __webpack_public_path__ + "static/intralox-logo-box-194a1e40631d2cf9cd7d463fa5afc04b.svg";